module.exports = __webpack_public_path__ + "static/img/middleItem3.9615135.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/modularMain/middleItem3.png
// module id = MOy2
// module chunks = 31